export default [
  {
    path: 'attestation-work',
    name: 'attestation-work',
    component: () => import('@/views/pages/attestation-work/View.vue'),
    meta: {
      pageTitle: 'Attestation work',
      breadcrumb: [
        {
          text: 'Attestation work',
          active: true,
        },
      ],
    },
  },
]
